import { useBrands, useTranslations      } from "context";

export const T = (props) => {
    const { currentBrand } = useBrands();
    const { tr } = useTranslations();
    const { children, params={} } = props;
    const key = children?.join ? children.join('') : children;
    return typeof(key) == 'string' ? tr(key) : children;
};